const orderTypesByCategory = {
  bookings: "courtBooking,bookingRefund",
  membership:
    "upgradeMembership,upgradeMembershipByAdmin,premiumRefund",
  tournaments:
    "eventRegistration,eventWithdrawal,eventRefund,waitingListRefund",
  wallet:
    "topUp,topUpByAdmin,subtractByAdmin,referralReward,firstTaskCompletion",
}

export const orderCategoryOptions = [
  { label: "All transactions", value: "all" },
  { label: "Tournaments", value: "tournaments" },
  { label: "Membership", value: "membership" },
  { label: "Wallet & rewards", value: "wallet" },
  { label: "Bookings", value: "bookings" },
]

export const buildOrderQueryOptions = (category, previousOptions = {}) => {
  const { type, ...optionsWithoutType } = previousOptions
  const nextOptions = { ...optionsWithoutType, page: 1 }
  const selectedTypes = orderTypesByCategory[category]

  return selectedTypes
    ? { ...nextOptions, type: selectedTypes }
    : nextOptions
}
